// extracted by mini-css-extract-plugin
export default {"otherMenu":"OtherMenu_otherMenu__d2Uav","otherMenu_iconBox":"OtherMenu_otherMenu_iconBox__o++zf","otherMenu_countProducts":"OtherMenu_otherMenu_countProducts__mXWeD"};